import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import CustomButton from '../customButton';
import CustomDrawer from '../customDrawer';
import Chat from './chat';

const useStyles = makeStyles(() => ({
  drawerScrollWrapper: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 71px)',
    minHeight: 0,
    width: '100%',
  },
  drawerContent: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minHeight: 0,
    width: '100%',
  },
}));

/**
 * Button + drawer wrapper for the HRIS leveling agent chat.
 *
 * Usage:
 *   import LevelingAgent from 'components/shared/levelingAgent';
 *   <LevelingAgent auth={auth} />
 */
const LevelingAgent = ({
  translations,
  auth,
  isDisabled = false,
  onGetLevelingFrameworks,
  buttonClassName = undefined,
  className = undefined,
}) => {
  const classes = useStyles();
  const [isOpened, setIsOpened] = useState(false);

  const handleOpen = useCallback(() => {
    setIsOpened(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpened(false);
  }, []);

  return (
    <>
      <CustomButton
        className={buttonClassName}
        type="aiDarkRoundedOutlined"
        onClick={handleOpen}
        disabled={isDisabled}
      >
        {translations.openLevelingAgentButtonLabel}
      </CustomButton>
      <CustomDrawer
        title={translations.title}
        isOpened={isOpened}
        onClose={handleClose}
        scrollWrapperClass={classes.drawerScrollWrapper}
        contentClass={classes.drawerContent}
        disableScroll
        isLarge
      >
        <Chat
          translations={translations}
          auth={auth}
          isDisabled={isDisabled}
          onGetLevelingFrameworks={onGetLevelingFrameworks}
          className={className}
        />
      </CustomDrawer>
    </>
  );
};

LevelingAgent.propTypes = {
  translations: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool,
  onGetLevelingFrameworks: PropTypes.func.isRequired,
  buttonClassName: PropTypes.string,
  className: PropTypes.string,
};

export default LevelingAgent;
